enum Priority {
    Blocker = "blocker",
    High = "high",
    Medium = "medium",
    Low = "low",
    NoPriority = "no_priority"
}

export {
  Priority
};
